import { Injectable } from '@angular/core';
import { UrlService } from '../../contants/url-service.constant';
import { HttpCustom } from '../http/http-custom.service';
import { Riesgo } from '../../models/cliente/riesgo.class';
import { HeaderPeticion } from '../../models/http/headerPeticion.class';
import { Configuracion } from '../../contants/configuracion.constant';


@Injectable()
export class RegulacionService {

  constructor(private httpCustom: HttpCustom) { }

  validarRiesgoConsultable(riesgos: Riesgo[]) {
    let headerPeticion  = [];
    headerPeticion.push(new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando'));
    headerPeticion.push(new HeaderPeticion(Configuracion.HEADER_HOST_ENDPOINT, Configuracion.HEADER_HOST_ENDPOINT_REGULACION_VALUE));
    headerPeticion.push(new HeaderPeticion(Configuracion.HEADER_HOST_PORT, Configuracion.HEADER_HOST_PORT_REGULACION_VALUE));
    headerPeticion.push(new HeaderPeticion(Configuracion.HEADER_HOST_METHOD, Configuracion.HEADER_HOST_METHOD_REGULACION_VALUE));
    return new Promise((resolve, reject) => {
      this.httpCustom.postServiceWithHeaders(UrlService.VALIDAR_RIESGO_CONSULTABLE, riesgos, headerPeticion).subscribe(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );


    });

  }
}



// WEBPACK FOOTER //
// ./src/app/services/regulacion/regulacion.service.ts